import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../Context/GlobalContext";
import { FaEraser, FaUpload } from "react-icons/fa";
import Loading from "../Extra/Loading";
import { getCurrentDate } from "../Utilitie";
import { MdInsertChart } from "react-icons/md";
import { Toast, ToastContainer } from "react-bootstrap";
import { IoIosCloudUpload } from "react-icons/io";
import SuccessMsg from "../Extra/SuccessMsg";
import FailedMsg from "../Extra/FailedMsg";

const Pp02Insertion = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const { userData } = useGlobalContext();

  const [result, setResult] = useState(null);
  const [allOk, setAllOk] = useState(true); ///add validation and condition
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const rows = 4;
  const cols = 16;
  const currentDate = getCurrentDate();
  // Define default values for the first two columns
  const defaultValues = [
    ["MEXP", currentDate],
    ["PASS", currentDate],
    ["TOTAL", currentDate],
    ["TOD", currentDate],
  ];

  const [gridData, setGridData] = useState(
    Array(rows)
      .fill()
      .map((_, rowIndex) => [
        defaultValues[rowIndex][0], // Default first column (Read-Only)
        defaultValues[rowIndex][1], // Default second column (Editable Date)
        ...Array(cols - 2).fill(""), // Empty values for other columns
      ])
  );

  const [messageDisplay, setMessageDisplay] = useState(false);

  const clearAll = () => {
    setGridData(
      Array(rows)
        .fill()
        .map((_, rowIndex) => [
          defaultValues[rowIndex][0], // Retain default first column
          defaultValues[rowIndex][1], // Retain default second column
          ...Array(cols - 2).fill(""), // Clear other columns
        ])
    );
  };
  useEffect(() => {
    if (result?.message === "Data inserted successfully") {
      setMessageDisplay(true);
      clearAll();
    }

    const timer = setTimeout(() => {
      setMessageDisplay(false);
    }, 3000);

    return () => clearTimeout(timer); // Cleanup to prevent memory leaks
  }, [result]);
  const handleChange = (row, col, value) => {
    const newData = [...gridData];
    // newData[row][col] = value; if want to chage seprateli the date for each row
    newData[0][1] = value; // changing  to the same date for each row
    newData[1][1] = value;
    newData[2][1] = value;
    newData[3][1] = value;
    setGridData(newData);
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData.getData("text");
    const rowsData = clipboardData.split("\n").map((row) => row.split("\t"));

    const newGridData = [...gridData];

    rowsData.forEach((row, rIndex) => {
      if (rIndex >= rows) return; // Prevent overflow

      row.forEach((cell, cIndex) => {
        if (cIndex >= cols - 2) return; // Prevent overflow
        newGridData[rIndex][cIndex + 2] = cell.trim(); // Paste from 3rd column
      });
    });

    setGridData(newGridData);
  };
  const sendToBackend = async () => {
    setLoading(true);
    let newArray = gridData.map((array) => {
      array.push(userData.id);
      return array;
    });

    try {
      const response = await fetch(`${urlPrefix}insert`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newArray),
      });
      const dataResult = await response.json();
      setResult(dataResult);
      setLoading(false);
      setShow(true);
    } catch (error) {
      setLoading(false);
      setError(error);
      console.error("Error sending data:", error);
    }
  };

  return (
    <div className="container text-center mt-12" style={{ minHeight: "95vh" }}>
      <div className="papaDiv text-start">
        <h4>
          <MdInsertChart />
          Punctuality Performance
        </h4>
        <h5 className="ps-2">
          insert data in table <b style={{ color: "red" }}>"pp02"</b>
        </h5>
      </div>
      <table
        className="table table-striped table-hover"
        border="1"
        cellPadding="1"
        onPaste={handlePaste}
      >
        <thead>
          <tr className="table-dark" style={{ fontSize: "12px" }}>
            <th style={{ border: "1px solid gray" }}>T_TYPE</th>
            <th style={{ border: "1px solid gray" }}>PP_DATE</th>
            <th style={{ border: "1px solid gray" }}>SCH</th>
            <th style={{ border: "1px solid gray" }}>RPT</th>
            <th style={{ border: "1px solid gray" }}>NOT_RPT</th>
            <th style={{ border: "1px solid gray" }}>BT</th>
            <th style={{ border: "1px solid gray" }}>RT</th>
            <th style={{ border: "1px solid gray" }}>MKUP</th>
            <th style={{ border: "1px solid gray" }}>NLT</th>
            <th style={{ border: "1px solid gray" }}>LT</th>
            <th style={{ border: "1px solid gray" }}>TODAY_CY</th>
            <th style={{ border: "1px solid gray" }}>UPTO_M_CY</th>
            <th style={{ border: "1px solid gray" }}>TODAY_LY</th>
            <th style={{ border: "1px solid gray" }}>UPTO_M_LY</th>
            <th style={{ border: "1px solid gray" }}>CY</th>
            <th style={{ border: "1px solid gray" }}>LY</th>
          </tr>
        </thead>

        <tbody>
          {gridData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, colIndex) => (
                <td key={colIndex} style={{ border: "1px solid gray" }}>
                  {colIndex === 0 ? (
                    // Read-only first column
                    <input
                      type="text"
                      value={cell}
                      style={{
                        width: "60px",
                        backgroundColor: "#e0e0e0",
                        border: "none",
                      }}
                      // readOnly
                    />
                  ) : colIndex === 1 ? (
                    // Editable date input for second column
                    <input
                      type="date"
                      max={currentDate}
                      value={cell}
                      style={{ width: "110px" }}
                      onChange={(e) =>
                        handleChange(rowIndex, colIndex, e.target.value)
                      }
                    />
                  ) : (
                    // Other editable inputs
                    <input
                      type="text"
                      value={cell}
                      style={{ width: "60px" }}
                      onChange={(e) =>
                        handleChange(rowIndex, colIndex, e.target.value)
                      }
                    />
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div>
        {loading ? <Loading /> : null}
        {result && result?.insertion ? (
          <SuccessMsg
            head={"Success"}
            message={result?.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          <FailedMsg
            head={"Failed"}
            message={`${result?.message} ,${result?.error}`}
            show={show}
            setShow={setShow}
          />
        )}
      </div>
      <div>
        <button
          className=" m-1 btn btn-sm btn-outline-danger"
          onClick={clearAll}
        >
          <FaEraser /> Clear All
        </button>
        <button
          className={` m-1 btn btn-sm btn-outline-success ${
            !allOk ? "disabled" : null
          }`}
          onClick={sendToBackend}
        >
          <FaUpload /> Upload
        </button>
      </div>
    </div>
  );
};

export default Pp02Insertion;
